export class CustomImageMaterialData {
  public image: HTMLImageElement;
  public width: number;
  public height: number;

  public constructor(image: HTMLImageElement, width: number, height: number) {
    this.image = image;
    this.width = width;
    this.height = height;
  }
}
